package gr.tech.site.components.states

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.styles.states.UtilityPartnerCardStyle
import gr.tech.site.styles.states.UtilityPartnerContentStyle
import gr.tech.site.styles.states.UtilityPartnerDrawerStyle
import gr.tech.site.styles.states.UtilityPartnerWrapperStyle
import org.jetbrains.compose.web.dom.*

data class UtilityCardData(
    val utilityName: String,
    val state: String,
    val utilityParam: String,
    val favorite: Boolean = false,
    val description: String = "",
    val bullets: List<String> = emptyList()
)

@Composable
fun UtilityPartnerGrid(cards: List<UtilityCardData>) {
    if (cards.size == 1) {
        val card = cards[0]
        Div(attrs = Modifier.classNames("d-flex", "justify-content-center").toAttrs()) {
            Div(attrs = Modifier.classNames("w-100", "w-md-50", "w-lg-25").toAttrs()) {
                UtilityPartnerCard(card.utilityName, card.state, card.utilityParam, card.favorite)
            }
        }
    } else {
        Div(
            attrs = Modifier.classNames(
                "row",
                "row-cols-2",    // 2-up on mobile
                "row-cols-sm-3", // 3-up on small
                "row-cols-lg-4", // 4-up on desktop
                "gx-3",          // tight horizontal gap
                "gy-5"           // generous vertical gap so the hover drawer has room
            ).toAttrs()
        ) {
            cards.forEach { card ->
                Div(attrs = Modifier.classNames("col").toAttrs()) {
                    UtilityPartnerCard(card.utilityName, card.state, card.utilityParam, card.favorite)
                }
            }
        }
    }
}

@Composable
fun UtilityPartnerCard(
    utilityName: String,
    //description: String,
    //bullets: List<String> = emptyList(),
    state: String,
    utilityParam: String,
    favorite: Boolean = false
) {
    // Wrapper is the link — hover on it drives both card lift and drawer reveal
    Link(
        path = "/contact-us?state=$state&utility=$utilityParam",
        modifier = UtilityPartnerWrapperStyle.toModifier(),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
        openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
        openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE
    ) {
        // Inner card — overflow:hidden clips logo to border-radius, z-index:1 covers hidden drawer
        Div(attrs = UtilityPartnerCardStyle.toModifier().classNames("utility-card").toAttrs()) {
            H5(attrs = Modifier.classNames("fw-bold", "my-4", "w-100", "text-center").toAttrs()) {
                Text(if (favorite) "$utilityName *" else utilityName)
            }
//            Div(attrs = UtilityPartnerContentStyle.toModifier().toAttrs()) {
//                P(attrs = Modifier.classNames("mb-0").toAttrs()) {
//                    Text(description)
//                }
//                if (bullets.isNotEmpty()) {
//                    Ul(attrs = Modifier.classNames("mt-2", "mb-0", "ps-3").toAttrs()) {
//                        bullets.forEach { bullet ->
//                            Li { Text(bullet) }
//                        }
//                    }
//                }
//            }
        }

        // Drawer — sibling to the card so it escapes overflow:hidden
        // translateY(-100%) hides it behind the card on desktop; wrapper hover slides it out
        Div(attrs = UtilityPartnerDrawerStyle.toModifier().classNames("utility-drawer").toAttrs()) {
            Text("Contact us about $utilityName →")
        }
    }
}
